import CommentCardMenu from './CommentCardMenu';

export default CommentCardMenu;
